import { c as _c } from "react/compiler-runtime";
import { FieldsEditType } from '@systemeio/digital-store-shared';
import { BUTTON_BASE_CLASS_NAME as BASE_CLASS_NAME, BUTTON_BASE_FLEX_CLASS_NAME as BASE_FLEX_CLASS_NAME, ContactFiledInterface, FormSelectDataType, getContactFieldTitle, ListBoxSelect } from '@systemeio/ui';
import React, { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { AddIcon } from '@systemeio/ui/icons';
interface StoreAddFieldProps {
  fields?: ContactFiledInterface[];
  onAdd: (field: FieldsEditType) => void;
}
const StoreAddField: FC<StoreAddFieldProps> = t0 => {
  const $ = _c(13);
  const {
    fields,
    onAdd
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== fields) {
    t1 = fields?.map(_temp);
    $[0] = fields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data = t1;
  const disabled = fields?.length === 0;
  let t2;
  if ($[2] !== fields || $[3] !== onAdd) {
    t2 = data_0 => {
      if (!data_0) {
        return;
      }
      const field = fields?.find(f_0 => f_0.slug === data_0);
      if (field) {
        onAdd({
          fieldName: getContactFieldTitle(field),
          slug: field.slug,
          required: false
        });
      }
    };
    $[2] = fields;
    $[3] = onAdd;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== disabled || $[6] !== t) {
    t3 = () => <div className={twMerge(BASE_CLASS_NAME, BASE_FLEX_CLASS_NAME, "bg-brand-primary text-background-secondary hover:bg-brand-primary-hover px-4", disabled && "bg-text-secondary/50 hover:bg-text-secondary/50")}><AddIcon />{t("dashboard.store.item.add_field")}</div>;
    $[5] = disabled;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== data || $[9] !== disabled || $[10] !== t2 || $[11] !== t3) {
    t4 = <ListBoxSelect buttonClassName="w-fit self-center rounded-lg" value={undefined} data={data} disabled={disabled} onChange={t2}>{t3}</ListBoxSelect>;
    $[8] = data;
    $[9] = disabled;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default StoreAddField;
function _temp(f) {
  return {
    id: f.slug,
    caption: getContactFieldTitle(f)
  };
}